module.exports = __webpack_public_path__ + "img/3_no.8d36773e.svg";